<ng-container *ngIf="clusters.length > 0 || general">
  <!-- Pie Chart + Cluster Table -->
  <div *ngIf="clusters.length > 0" class="row align-items-center mb-4">
    <div class="col-md-5 d-flex justify-content-center mb-3 mb-md-0">
      <div class="stat-pie rounded-circle flex-shrink-0" [style.background]="pieGradient"></div>
    </div>
    <div class="col-md-7">
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <thead>
            <tr>
              <th>Color</th>
              <th>Description</th>
              <th class="text-end">{{ clusters[0]?.area_unit || 'ha' }}</th>
              <th class="text-end">%</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cluster of clusters">
              <td>
                <span class="d-inline-block rounded-circle p-2 align-middle" [style.background-color]="'#' + cluster.color"></span>
              </td>
              <td>{{ cluster.label }}</td>
              <td class="text-end">{{ cluster.area | number:'1.2-2' }}</td>
              <td class="text-end">{{ cluster.percentage | number:'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- General Summary Card -->
  <div *ngIf="general" class="bg-body-tertiary rounded py-3 px-4 text-center">
    <div class="fs-5 fw-semibold mb-1">{{ general.general_label }}</div>
    <div class="fs-4 fw-bold">{{ general.general_stress_area }} {{ general.general_area_unit }}</div>
  </div>
</ng-container>

<!-- Fallback: remaining stat keys as raw JSON -->
<div *ngFor="let entry of remainingEntries" class="mt-3">
  <label class="form-label text-muted small mb-1">{{ entry.key }}</label>
  <pre class="mb-0 small bg-dark text-light p-2 rounded" style="max-height: 300px; overflow-y: scroll; overscroll-behavior: contain;">{{ entry.value }}</pre>
</div>
